import 'reflect-metadata';
import "../node_modules/@springbig/vue-components/dist/vue-components.css";
import "../node_modules/@springbig/sb-components/dist/springbig-components.esm.css";
import "./assets/icons/regular-icons";
import "./assets/icons/solid-icons";
import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import config from "./config";
import axios from "./services/api/axios";
import Plugin from "@springbig/vue-components";
import { container, tokens } from '@springbig/sb-components';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { rollbar } from './services/rollbar';
import { store } from './store/store';

if(config.rollbar.enabled){
  container.register(tokens.rollbar, { useValue: rollbar })

  Vue.prototype.$rollbar = rollbar

  Vue.config.errorHandler = (err, vm) => {
    rollbar.error(err);
    throw err; // rethrow
  };
}

container.register(tokens.store, { useValue: store })

Vue.component('fai', FontAwesomeIcon)

Vue.use(Plugin);

Vue.use({
  install (Vue) {
    Vue.prototype.$api = axios
  }
})

Vue.component('fai', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')